export default "__VITE_ASSET__f_MPtUZ$__"